import { useNavigate } from "react-router-dom";
import { Phone, Mail, Clock, MessageCircle, MapPin, ExternalLink } from "lucide-react";
import { MAPS_URL } from "@/lib/business-info";

const BG =
    "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/4d787d13326aa849ee0d5f6e6dfc136dcc1f6aeef00df5aa52ca8f2fd8814a1e.jpeg";

const WA_RAW = "528116289267";
const TEL_RAW = "528189899822";
const TEL_DISPLAY = "+52 81 8989 9822";
const WA_DISPLAY = "+52 81 1628 9267";
const EMAIL = "info@eclipsecubiertas.com";
const WHATSAPP_URL = "https://wa.me/" + WA_RAW + "?text=" + encodeURIComponent("Hola, me interesa cotizar un proyecto con Eclipse Cubiertas.");

export default function FinalCTA() {
    const navigate = useNavigate();
    return (
        <section data-testid="final-cta" className="relative overflow-hidden">
            <div className="absolute inset-0 bg-cover bg-center z-0" style={{ backgroundImage: `url(${BG})` }} aria-hidden />
            <div className="absolute inset-0 bg-eclipse-primary/80 z-10" aria-hidden />

            <div className="relative z-20 container-eclipse py-20 sm:py-28 text-center">
                <p className="font-display font-bold text-xs tracking-[0.3em] text-eclipse-cta mb-5">EMPECEMOS HOY</p>
                <h2 data-testid="final-cta-title" className="font-display font-black text-white text-3xl sm:text-5xl lg:text-6xl tracking-tight leading-tight mb-5">
                    ¿Tienes un proyecto <span className="text-eclipse-cta">en mente?</span>
                </h2>
                <p className="text-white/85 text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
                    Cotización gratuita en menos de 24 horas. Ingenieros especializados.
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                    <button data-testid="final-cta-flexshade" onClick={() => navigate("/flexshade")} className="btn-eclipse-cta px-7 py-4 rounded-sm text-sm tracking-wider uppercase">
                        FlexShade — Proyectos modulares
                    </button>
                    <button data-testid="final-cta-skycover" onClick={() => navigate("/velarias")} className="btn-eclipse-outline px-7 py-4 rounded-sm text-sm tracking-wider uppercase">
                        Skycover — Proyectos a la medida
                    </button>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
                    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="final-cta-whatsapp" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-sm bg-[#25D366] hover:bg-[#1ebd5b] text-white font-display font-bold text-sm uppercase tracking-wider transition-colors">
                        <MessageCircle className="w-4 h-4" />
                        WhatsApp {WA_DISPLAY}
                    </a>
                    <a href={`tel:+${TEL_RAW}`} data-testid="final-cta-phone-btn" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-sm border border-white/40 text-white hover:bg-white/10 font-display font-bold text-sm uppercase tracking-wider transition-colors">
                        <Phone className="w-4 h-4" />
                        Llamar {TEL_DISPLAY}
                    </a>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 text-white/85 text-sm">
                    <a href={`tel:+${TEL_RAW}`} data-testid="final-cta-phone" className="inline-flex items-center gap-2 hover:text-eclipse-cta transition-colors">
                        <Phone className="w-4 h-4 text-eclipse-cta" />
                        {TEL_DISPLAY}
                    </a>
                    <a href={`mailto:${EMAIL}`} data-testid="final-cta-email" className="inline-flex items-center gap-2 hover:text-eclipse-cta transition-colors">
                        <Mail className="w-4 h-4 text-eclipse-cta" />
                        {EMAIL}
                    </a>
                    <span className="inline-flex items-center gap-2">
                        <Clock className="w-4 h-4 text-eclipse-cta" />
                        Lun-Vie 9-18h
                    </span>
                </div>

                <a
                    href={MAPS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-cta-maps"
                    className="inline-flex items-center gap-1.5 mt-6 text-xs text-white/70 hover:text-eclipse-cta transition-colors underline underline-offset-4 decoration-white/30 hover:decoration-eclipse-cta"
                >
                    <MapPin className="w-3.5 h-3.5" />
                    Cómo llegar a nuestras oficinas
                    <ExternalLink className="w-3 h-3 opacity-70" />
                </a>
            </div>
        </section>
    );
}
